import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as MentionIcon } from "../../../images/mention-icon.svg";
import EmojiPicker from "../EmojiPicker";
import ComposerSendButton from "./ComposerSendButton";
import ImageUploadButton from "../ImageUploadButton";

export default function FooterActions({
  onToggleFormatting,
  formattingActive = false,
  onInsertMention,
  onStartVideo,
  onRecordAudio,
  onCreateCanvas,
  onSend,
  canSend = false,
  isSending = false,
  onSelectEmoji,
  onSelectImages,
  accept = "image/*",
  multiple = true,
  maxFileSizeMB = 25,
}) {
  return (
    <div className="composer-v2__footer">
      <div className="composer-v2__left">
        <ImageUploadButton
          onSelectImages={onSelectImages}
          accept={accept}
          multiple={multiple}
          maxFileSizeMB={maxFileSizeMB}
          buttonClassName="composer-v2__circle"
        />
        <button
          type="button"
          className={`composer-v2__tool ${formattingActive ? 'composer-v2__tool--active' : ''}`}
          aria-label="Toggle formatting"
          aria-pressed={Boolean(formattingActive)}
          onClick={onToggleFormatting}
        >
          Aa
        </button>
        <div className="chat-composer__emoji">
          <EmojiPicker onSelectEmoji={onSelectEmoji} anchorSelector=".composer-v2" />
        </div>
        <button type="button" className="composer-v2__tool" aria-label="Mention someone" onClick={onInsertMention}>
          <MentionIcon aria-hidden="true" focusable="false" />
        </button>
        <span className="composer-v2__divider" aria-hidden="true" />
      </div>
      <div className="composer-v2__right">
        <span className="composer-v2__divider" aria-hidden="true" />
        <ComposerSendButton
          onSend={onSend}
          isBusy={isSending}
          canSend={canSend}
          size="large"
        />
        <span className="composer-v2__divider" aria-hidden="true" />
        {/* <button type="button" className="composer-v2__caret" aria-label="More">
          <CaretDownIcon />
        </button> */}
      </div>
    </div>
  );
}

FooterActions.propTypes = {
  onToggleFormatting: PropTypes.func,
  formattingActive: PropTypes.bool,
  onInsertMention: PropTypes.func,
  onStartVideo: PropTypes.func,
  onRecordAudio: PropTypes.func,
  onCreateCanvas: PropTypes.func,
  onSend: PropTypes.func.isRequired,
  canSend: PropTypes.bool,
  isSending: PropTypes.bool,
  onSelectEmoji: PropTypes.func.isRequired,
  onSelectImages: PropTypes.func,
  accept: PropTypes.string,
  multiple: PropTypes.bool,
  maxFileSizeMB: PropTypes.number,
};
